module.exports = __webpack_public_path__ + "img/img_poa_edge_missing.ffb0a63c.png";